import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad, Route
} from '@angular/router';
import { AuthService } from './auth.service';
import { Observable} from "rxjs/Observable";



@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    console.log("authGuard.canActivate url:"+ url);

    if (!this.authService.user) {
      this.router.navigate(['login']);
      return false;
    }

    if (!route.data || !route.data["permission"]) {
      return true;
    }

    if (this.authService.isGranted(route.data["permission"])) {
      return true;
    }

    this.router.navigate([this.selectBestRoute()]);
    return false;

    //return this.checkLogin(url);
  }


  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;

    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {

    if (this.authService.isLoggedIn) { return true; }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate(['/login']);
    return false;
  }

  checkPermission(permissionName: string): boolean {
 
    return this.authService.isGranted(permissionName);


  }

  selectBestRoute(): string {
    if (!this.authService.user) {
      return '/login';
    }

    // if (this.authService.isGranted('Pages.Users')) {
    //     return '/app/admin/users';
    // }

    return '/';
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/auth-guard.service.ts